import { render, staticRenderFns } from "./EducationalItemReviewList.vue?vue&type=template&id=d8aeac88&"
import script from "./EducationalItemReviewList.vue?vue&type=script&lang=js&"
export * from "./EducationalItemReviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports